/* カート: 数量変更・削除（本番 cart.html の挙動を移植。Shopify Ajax Cart API） */
(function () {
  var list = document.getElementById('js-cart-list');
  if (!list) return;

  // 英語版では /en が付く
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function change(line, qty) {
    fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { location.reload(); });
  }

  list.querySelectorAll('.cart-qty').forEach(function (sel) {
    sel.addEventListener('change', function () {
      change(parseInt(sel.getAttribute('data-index'), 10), parseInt(sel.value, 10));
    });
  });
  list.querySelectorAll('.cart-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      change(parseInt(btn.getAttribute('data-index'), 10), 0);
    });
  });

  var checkout = document.getElementById('js-checkout');
  if (checkout) {
    checkout.addEventListener('click', function (e) {
      e.preventDefault();
      // 英語版では /en が付く（付けないとレジ画面が日本語になる）。window.Shopify.routes.root から組み立てる
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      location.href = root + 'checkout';
    });
  }
})();
